import * as React from 'react';

import MoneyStack56 from './MoneyStack56';

export const moneyStack56 = () => <MoneyStack56 />;

export default {
    title: 'Illustration|MoneyStack56',
    component: MoneyStack56,
    parameters: {
        notes: "`import MoneyStack56 from 'box-ui-elements/es/illustration/MoneyStack56';`",
    },
};
